import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { default as ReactDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';
export const Dropzone = (dropzoneProps) => {
    return (_jsx(ReactDropzone, { ...dropzoneProps, children: ({ getRootProps, getInputProps }) => {
            const { ...rootProps } = getRootProps();
            return (_jsxs(Box, { ...rootProps, sx: (theme) => ({
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    border: '1px dashed',
                    borderColor: 'divider',
                    width: '100%',
                    minHeight: 120,
                    px: 3,
                    py: 4,
                    borderRadius: 2.5,
                    transition: theme.transitions.create(['background-color'], {
                        duration: theme.transitions.duration.standard,
                    }),
                    '&:hover': {
                        backgroundColor: 'action.hover',
                    },
                }), children: [_jsx("input", { ...getInputProps() }), _jsx(Typography, { children: "Datei reinziehen oder hier klicken" })] }));
        } }));
};
